import { render, staticRenderFns } from "./IriValue.vue?vue&type=template&id=27ddcd23&"
import script from "./IriValue.vue?vue&type=script&lang=js&"
export * from "./IriValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports